export default __webpack_public_path__ + "static/media/btn_collab_shuffle.412c4f81.svg";